import { render, staticRenderFns } from "./Overall.vue?vue&type=template&id=aa038940&lang=pug&"
import script from "./Overall.vue?vue&type=script&lang=ts&"
export * from "./Overall.vue?vue&type=script&lang=ts&"
import style0 from "./Overall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports